export default {
  s: '%d másodperc',
  smicro: '%d mp',
  smid: '%d mp',

  ss: '%d másodperc',
  ssmicro: '%d mp',
  ssmid: '%d mp',

  m: '%d perc',
  mmicro: '%d p',
  mmid: '%d perc',

  mm: '%d perc',
  mmmicro: '%d p',
  mmmid: '%d perc',

  h: '%d óra',
  hmicro: '%d ó',
  hmid: '%d óra',

  hh: '%d óra',
  hhmicro: '%d ó',
  hhmid: '%d óra',

  d: '%d nap',
  dmicro: '%d n',
  dmid: '%d nap',

  dd: '%d nap',
  ddmicro: '%d n',
  ddmid: '%d nap',
};
